import { useMantineColorScheme } from '@mantine/core';
import { useHotkeys } from '@mantine/hooks';

export default function Hotkeys() {
  const { toggleColorScheme } = useMantineColorScheme();

  useHotkeys([['ctrl+j', toggleColorScheme]]);

  return null;
}
